import '@/global.css';
import { Stack } from 'expo-router';
import { StatusBar } from 'expo-status-bar';
import 'react-native-reanimated';

import ProviderContent from '@/components/provider-content';
import { RootInitializer } from '@/components/root-initializer';
import { PortalProvider } from '@/components/ui/portal';
import { initSentry } from '@/lib/sentry';
import * as Sentry from '@sentry/react-native';
import { HeaderProvider, useHeaderContext } from '@/components/header-context';
import { AnimatedHeader } from '@/components/animated-header';

// Initialize Sentry
initSentry();

export const unstable_settings = {
  anchor: '(tabs)',
};

function LayoutContent() {
  const { headerTranslateY } = useHeaderContext();
  return (
    <>
      <Stack>
        <Stack.Screen name='index' options={{ headerShown: false }} />
        <Stack.Screen name='compare' options={{ headerShown: false }} />
        <Stack.Screen name='benchmarking' options={{ headerShown: false }} />
        <Stack.Screen name='admin' options={{ headerShown: false }} />
        <Stack.Screen name='forgot-password' options={{ headerShown: false }} />
        <Stack.Screen name='faq' options={{ headerShown: false }} />
      </Stack>
      <AnimatedHeader translateY={headerTranslateY} />
      <StatusBar style='auto' />
    </>
  );
}

export default Sentry.wrap(function RootLayout() {
  return (
    <RootInitializer>
      <ProviderContent>
        <PortalProvider>
          <HeaderProvider>
            <LayoutContent />
          </HeaderProvider>
        </PortalProvider>
      </ProviderContent>
    </RootInitializer>
  );
});
